import { Languages } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@cuspar/ui';
import i18n from 'i18next';
import { useAuthStore } from '../../state/authStore';

const languages = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
] as const;

export function LanguageSwitcher() {
  const editUserProfile = useAuthStore((s) => s.editUserProfile);
  const user = useAuthStore((s) => s.user);

  const handleLanguageChange = (locale: string) => {
    i18n.changeLanguage(locale);
    if (user) {
      editUserProfile({ locale: locale as 'de' | 'en' | 'fr' | 'it' });
    }
  };

  const currentLang = languages.find((l) => l.code === i18n.language) ?? languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className='focus:ring-transparent focus-visible:ring-transparent' asChild>
        <Button variant='ghost' size='icon'>
          <Languages className='h-5 w-5' />
          <span className='sr-only'>{currentLang.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        {languages.map((lang) => (
          <DropdownMenuItem key={lang.code} onClick={() => handleLanguageChange(lang.code)}>
            <span className='mr-2 font-mono text-xs uppercase'>{lang.code}</span>
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
